import { getIconName } from "@/utils/mode-commande";

export const shippingMethodOverviewProps = () => ({
  service: {
    type: Object,
    required: true
  },
  dateRetrait: {
    type: String,
    required: true
  },
  tarif: {
    type: [Number, String],
    required: false,
    default: "Gratuit"
  },
  typePanier: {
    type: String,
    required: true
  }
})

export const useShippingMethodOverview = (props) => {
  const iconName = computed(() => {
    return getIconName(props.service ? props.service.type_picto.code : null);
  })
  return { iconName }
}